/**
 * Endings that survive obfuscation. A censored list is read to check *which* words are in it, and a
 * bare `f**k` cannot be told from `f**ked` — the suffix is what makes a masked word identifiable.
 *
 * TODO: store this in the backend and fetch it.
 */
const PRESERVED_ENDINGS = [
  'ed', 'ing', 'tion', 'sion', 'ly', 'est', 's', 'es', 'ies', 'ness', 'ment', 'able', 'ible',
  'ful', 'less', 'ous', 'ious', 'al', 'ic', 'ate',
];

/** First and last character, `*` between, common suffix kept: `f**k`, `d****ed`. */
export function obfuscateWord(word: string): string {
  if (word.length <= 2) {
    return word;
  }

  let ending = '';
  let baseWord = word;

  for (const suffix of PRESERVED_ENDINGS) {
    // Only strip an ending if what is left is still long enough to be worth masking.
    if (word.toLowerCase().endsWith(suffix) && word.length > suffix.length + 2) {
      ending = word.slice(-suffix.length);
      baseWord = word.slice(0, -suffix.length);
      break;
    }
  }

  if (baseWord.length <= 2) {
    return baseWord + ending;
  }

  const middle = '*'.repeat(baseWord.length - 2);
  return `${baseWord[0]}${middle}${baseWord[baseWord.length - 1]}${ending}`;
}
